module.exports = __webpack_public_path__ + "static/favicon--terrace-06288f32d8e70e51161b17e4ba7d5677.ico";